import { useGenerateEmissorOrderReceiptPdfMutation } from '../services/contractOrderReceiptApi';
import { usePdfDownload } from './usePdfDownload';
export function useEmissorOrderReceiptPdf(scopeKey = '') {
    const [trigger] = useGenerateEmissorOrderReceiptPdfMutation();
    const { download, ...state } = usePdfDownload(trigger, scopeKey);
    return { viewReceipt: download, ...state };
}
